import { switchURLapi } from "./baseURL"
import queryString from 'query-string'
import 'whatwg-fetch'

const apiURLRoot = switchURLapi("http://localhost:60562/api/", "http://source-qa.a.ynet.co.il/mShort/commerce/2018/ManaFalafelAPI/api/", "https://z.ynet.co.il/mShort/commerce/2018/ManaFalafelAPI/api/");

const _getData = (url, params, slashParams = false) => {
    let _params = slashParams ?
        params.map(p => `/${p}`).join('') :
        queryString.stringify(params)

    return fetch(`${url}${_params}`);
}

const _postData = (url, params) => {
    return fetch(url, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: "POST",
        body: queryString.stringify(params)
    });
}

const jsonPipe = response => response.json();

const ManotApi = {
    get: () => {
        return _getData(`${apiURLRoot}getmanot`)
            .then(jsonPipe);
    }
}

const saveVotes = {
    add: votes => _postData(`${apiURLRoot}save`, {
        votes
    })
}

export {
    ManotApi,
    saveVotes
}


// WEBPACK FOOTER //
// ./src/Components/Services/fetchService.js